(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-cro"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.currentScript&&document.currentScript.closest?null:null;
  document.querySelectorAll('.cro-pdp').forEach(function(pdp){
    var sid=pdp.getAttribute('data-section-id');
    var form=pdp.querySelector('#cro-product-form')||pdp.querySelector('.cro-form');
    var idInput=pdp.querySelector('[data-cro-variant-id]');
    var atcText=pdp.querySelector('[data-cro-atc-text]');
    var priceNow=pdp.querySelector('.cro-price-now');
    var variants=[];
    try{variants=JSON.parse(document.querySelector('[data-cro-variants="'+sid+'"]').textContent);}catch(e){}

    // Gallery carousel (mobile) — sync dots + thumbnails with swipe
    var track=pdp.querySelector('.cro-track');
    var gdots=pdp.querySelectorAll('.cro-gdot');
    var gthumbs=pdp.querySelectorAll('.cro-thumb');
    if(track){
      track.addEventListener('scroll',function(){
        var i=Math.round(track.scrollLeft/track.clientWidth);
        gdots.forEach(function(d,x){d.classList.toggle('on',x===i);});
        gthumbs.forEach(function(t,x){t.classList.toggle('on',x===i);});
      });
      gthumbs.forEach(function(t,i){t.addEventListener('click',function(){
        track.scrollTo({left:i*track.clientWidth,behavior:'smooth'});
      });});
      pdp.querySelectorAll('[data-cro-arrow]').forEach(function(a){
        a.addEventListener('click',function(){
          var dir=a.getAttribute('data-cro-arrow')==='next'?1:-1;
          track.scrollBy({left:dir*track.clientWidth,behavior:'smooth'});
        });
      });
    }

    // Offer carousel dots
    var otrack=pdp.querySelector('.cro-offer-track');
    var odots=pdp.querySelectorAll('.cro-odot');
    if(otrack && odots.length){
      otrack.addEventListener('scroll',function(){
        var card=otrack.querySelector('.cro-offer-card');
        var step=card?card.getBoundingClientRect().width+10:otrack.clientWidth;
        var i=Math.round(otrack.scrollLeft/step);
        odots.forEach(function(d,x){d.classList.toggle('on',x===i);});
      });
    }
    // Offers auto-scroll every 2 seconds
    if(otrack){
      var ocards=otrack.querySelectorAll('.cro-offer-card');
      if(ocards.length>1){
        var oi=0;
        setInterval(function(){
          if(document.hidden)return;
          oi=(oi+1)%ocards.length;
          var st=ocards[0].getBoundingClientRect().width+10;
          otrack.scrollTo({left:oi*st,behavior:'smooth'});
        },2000);
      }
    }

    // Sticky bar (mobile): visible by default, hidden only while the main Add-to-Cart is on screen
    var sticky=pdp.querySelector('.cro-stickybar');
    var realAtc=pdp.querySelector('.cro-btn-atc');
    if(sticky && realAtc && 'IntersectionObserver' in window){
      new IntersectionObserver(function(es){es.forEach(function(e){sticky.classList.toggle('cro-hidden', e.isIntersecting);});},{threshold:0.4}).observe(realAtc);
    }
    var sAdd=pdp.querySelector('[data-cro-sticky-add]');
    if(sAdd && realAtc){ sAdd.addEventListener('click',function(){ realAtc.click(); }); }
    var sBuy=pdp.querySelector('[data-cro-sticky-buy]');
    if(sBuy){ sBuy.addEventListener('click',function(){
      var id=idInput?idInput.value:null; if(!id){ if(realAtc) realAtc.click(); return; }
      sBuy.disabled=true;
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:parseInt(id,10),quantity:1}]})})
        .then(function(){window.location.href='/checkout';})
        .catch(function(){window.location.href='/checkout';});
    }); }

    // Quantity
    pdp.querySelectorAll('[data-cro-qty]').forEach(function(b){
      b.addEventListener('click',function(){
        var inp=pdp.querySelector('[data-cro-qty-input]');var v=parseInt(inp.value||'1',10);
        v=b.getAttribute('data-cro-qty')==='plus'?v+1:Math.max(1,v-1);inp.value=v;
      });
    });

    // Variant picker
    function selectedOptions(){
      return Array.prototype.map.call(pdp.querySelectorAll('.cro-swatches'),function(row){
        var c=row.querySelector('input:checked');return c?c.value:null;
      });
    }
    function money(cents){
      try{return (window.Shopify&&Shopify.formatMoney)?Shopify.formatMoney(cents):('₹'+(cents/100).toLocaleString('en-IN'));}
      catch(e){return '₹'+(cents/100);}
    }
    function update(){
      var opts=selectedOptions();
      var match=variants.find(function(v){return v.options.every(function(o,i){return o===opts[i];});});
      if(!match)return;
      if(idInput)idInput.value=match.id;
      if(priceNow)priceNow.textContent=money(match.price);
      var sPrice=pdp.querySelector('[data-cro-sticky-price]'); if(sPrice)sPrice.textContent=money(match.price);
      if(atcText)atcText.textContent=match.available?'Add to Cart':'Sold Out';
      var btn=pdp.querySelector('.cro-btn-atc');if(btn)btn.disabled=!match.available;
      var url=new URL(window.location);url.searchParams.set('variant',match.id);history.replaceState({},'',url);
    }
    pdp.querySelectorAll('.cro-swatches').forEach(function(row){
      row.querySelectorAll('.cro-sw').forEach(function(sw){
        sw.addEventListener('click',function(){
          row.querySelectorAll('.cro-sw').forEach(function(x){x.classList.remove('on');});
          sw.classList.add('on');sw.querySelector('input').checked=true;
          var lbl=pdp.querySelector('[data-opt-selected="'+row.getAttribute('data-opt-position')+'"]');
          if(lbl)lbl.textContent=sw.querySelector('input').value;
          update();
        });
      });
    });

    // Delivery estimate (today + business lead time from data attribute or default 6)
    var d=pdp.querySelector('[data-cro-delivery]');
    if(d){var lead=parseInt(d.getAttribute('data-lead')||'6',10);var dt=new Date();dt.setDate(dt.getDate()+lead);
      d.textContent=dt.toLocaleDateString('en-IN',{weekday:'short',day:'numeric',month:'short'});}

    // Recommendations (real "You may also like")
    var recWrap=pdp.querySelector('[data-cro-recs]');
    if(recWrap){
      fetch(recWrap.getAttribute('data-url')).then(function(r){return r.text();}).then(function(html){
        var doc=new DOMParser().parseFromString(html,'text/html');
        var grid=doc.querySelector('.cro-cards');
        var target=recWrap.querySelector('.cro-recs-target');
        if(grid&&target){target.appendChild(grid);}else{recWrap.style.display='none';}
      }).catch(function(){recWrap.style.display='none';});
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
